import { lazy, Suspense } from 'react';
import Spin from 'components/Spin';
import type { IBrandConfig } from './types';

const MissGroupSafeTermsOfService = lazy(
  () => import('pages/terms-of-service/miss-group-safe'),
);

const DSAFE_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: 'policy/dshop-policy.md',
  termsOfService: () => (
    <Suspense fallback={<Spin />}>
      <MissGroupSafeTermsOfService />
    </Suspense>
  ),
  vaultProject: 'dsafe',
  adaChat: false,
  accountDetails: true,
  secureUpload: false,
  plan: false,
  security: false,
  missingPII: false,
  finishSetup: false,
  darkwebDashboardCard: false,
  defaultBillingCategoryKey: 'privacy_breach',
  downloadsRecommended: false,
  copyRightText: 'Domainkeskus Safe. All rights reserved.',
  hasCustomerServiceSupport: false,
  horizontalVaultDashboardCards: true,
  ssoRedirectURL: null,
  carouselBanners: false,
  dwEmailVerification: {
    adaChat: false,
    signInButton: true,
    supportAt: null,
    availability: null,
  },
  supportPage: {
    pageTitle: {
      active: false,
    },
    customerSupportTitle: {
      active: false,
    },
    faq: {
      active: true,
    },
    pages: [
      {
        title: 'Support page',
        href: 'https://help.domainkeskus.com',
        icon: 'support-faq',
        customerSupport: false,
      },
    ],
    call: {
      active: false,
    },
    mail: {
      active: false,
    },
    email: {
      active: true,
      address: 'info@domainkeskus.com',
      customerSupport: true,
    },
  },
};

export default DSAFE_BRAND_CONFIG;
